import { saveAction } from "src/api/actionLogger";
export type Action = {
    actions: ActionItem[];
};

export type ActionItem = {
    action: string;
    category: string;
    label: string | null;
    value: string | null;
    createdAt: string;
};
const stackedActions: ActionItem[] = [];

export const stackAction = (action: ActionItem) => {
    stackedActions.push(action);
};

export const flushStackedActions = async () => {
    if (stackedActions.length === 0) return;
    const actionsToSend = [...stackedActions];
    stackedActions.length = 0; // Clear the stack
    try {
        await saveAction({ actions: actionsToSend });
    } catch (error) {
        // Re-add failed actions to the stack
        stackedActions.unshift(...actionsToSend);
        // Log the error for debugging
        // eslint-disable-next-line no-console
        console.error("Failed to save actions:", error);
    }
};

export const flushStackedActionsWithBeacon = async (): Promise<boolean> => {
    if (stackedActions.length === 0) return true;

    const actionsToSend = [...stackedActions];
    stackedActions.length = 0; // Clear the stack

    // Check if sendBeacon is available
    if (!navigator.sendBeacon) {
        await flushStackedActions();
        return true;
    }
    // Use sendBeacon - format data as Blob with proper content-type
    const data = JSON.stringify({ actions: actionsToSend });
    const blob = new Blob([data], { type: "application/json" });

    // Note: sendBeacon doesn't support custom headers like Authorization
    // get token from cookies
    const success = navigator.sendBeacon("/api/actionLogger", blob);
    if (!success) {
        // eslint-disable-next-line no-console
        console.warn("sendBeacon failed, actions may be lost");
    }

    return success;
};
